import { EditEmployee } from './EditEmployee';

export default EditEmployee;
